<template>
  <div class="card-body px-1">
    <span v-if="address.alias === 'home'" class="address__status-icon material-icons">home</span>
    <span v-else-if="address.alias === 'work'" class="address__status-icon material-icons">work</span>
    <span v-else-if="address.alias === 'favorite'" class="address__status-icon material-icons">favorite</span>
    <span v-else class="address__status-icon material-icons">add_circle</span>

    <div class="d-flex flex-column">
      <h6 class="order__summary">{{ address.alias }}</h6>
      <p>
        <small class="order__summary text-muted">{{ `${address.address}, ${address.extra}` }}</small>
      </p>
      <p>
        <small class="order__summary text-muted">{{ `${address.locality} -
          ${address.administrative_area}`}}</small>
      </p>
    </div>

    <div class="text-right">
      <button type="button" class=" d-flex align-items-center btn btn-sm"
        :class="checked ? 'btn-outline-secondary' : 'btn-outline-primary'" @click="setAddress">
          <span class="material-icons mr-1">{{ checked ? 'task_alt' : 'radio_button_unchecked' }}</span>
          {{ checked ? this.$t('address.chosen_one') : $t('action.select') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initAddress: { type: Object, required: true },
    checked: { type: Boolean, default: false }
  },
  data () {
    return {
      address: Object.assign({}, this.initAddress)
    }
  },
  methods: {
    setAddress () {
      this.$emit('update')
    }
  }
}
</script>
